import { render, staticRenderFns } from "./ServiceGuide.vue?vue&type=template&id=affc4064&scoped=true"
import script from "./ServiceGuide.vue?vue&type=script&lang=js"
export * from "./ServiceGuide.vue?vue&type=script&lang=js"
import style0 from "./ServiceGuide.vue?vue&type=style&index=0&id=affc4064&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affc4064",
  null
  
)

export default component.exports